package br.com.texeratx.boardgametimeapp.ui.screens.login

data class LoginUiState(
    val email: String = "",
    val password: String = "",
    val isLoading: Boolean = false,
    val isLogged: Boolean = false,
    val error: String? = null
)
